import { render, staticRenderFns } from "./tan_longtxt.vue?vue&type=template&id=4f657ea8&scoped=true"
import script from "./tan_longtxt.vue?vue&type=script&lang=js"
export * from "./tan_longtxt.vue?vue&type=script&lang=js"
import style0 from "./tan_longtxt.vue?vue&type=style&index=0&id=4f657ea8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f657ea8",
  null
  
)

export default component.exports